#import "./TrainingCourseAdminFields.graphql"

mutation PublishTrainingCourse($courseId: ID!) {
  publishTrainingCourse(input: { courseId: $courseId }) {
    trainingCourse {
      ...TrainingCourseAdminFields
    }
    assignedCount
  }
}
